module.exports = __webpack_public_path__ + "img/bg.aecb7d66.png";